import { combineReducers } from "redux";
import summary from "./summary/reducers";
import waiting from "./invoice/waitingReducers";
import paid from "./invoice/paidReducer";
import table from "./invoice/tableReducer";
import outstanding from "./outstanding/tableReducer";
import pending from "./invoice/pendingReducer";

const rootReducers = combineReducers({
  summary: summary,
  waiting: waiting,
  paid: paid,
  pending: pending,
  table: table,
  outstanding: outstanding
});

export default rootReducers;
